/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1256
 */

module.exports = "undefined" !== typeof ArrayBuffer && "undefined" !== typeof DataView
